import React from 'react';
import {List, Divider, Table, Collapse} from 'antd';

interface ExportData {
    system: SystemDto;
    name: string;
    description: string;
    id: number;
}

interface SystemDto {
    name: string
}

interface Props {
    exportDataList: ExportData[] | null | undefined;
}

const GroupedList: React.FC<Props> = ({exportDataList}) => {
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Beschreibung',
            dataIndex: 'description',
            key: 'description',
        },
    ];


    return (
        <Table
            style={{marginTop: '5px'}}
            bordered
            columns={columns}
            dataSource={exportDataList ?? []}
            pagination={false}
        />
    );
};

export default GroupedList;
